var _defs, _ellipse, _path, _line, _line2, _line3, _line4, _circle, _line5, _line6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArtilarIkonu4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    "data-name": "katman 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#55c595;}.cls-2{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:30px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\xC7al\u0131\u015Fma Y\xFCzeyi 42_1mdpi") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 353.92,
    cy: 555.77,
    rx: 174.36,
    ry: 261.66,
    transform: "matrix(0.93, -0.37, 0.37, 0.93, -181.5, 171.76)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M407.14,742.88a287.74,287.74,0,0,0,219.54,101.4C785.91,844.28,915,715.19,915,556S785.91,267.64,626.68,267.64A287.8,287.8,0,0,0,399.73,378.11"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 191.8,
    y1: 452.29,
    x2: 472.39,
    y2: 452.29
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 249.11,
    y1: 555.39,
    x2: 472.39,
    y2: 555.39
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 290.49,
    y1: 658.49,
    x2: 472.39,
    y2: 658.49
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 660.19,
    y1: 524.66,
    x2: 746.35,
    y2: 435.55
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 636.99,
    cy: 556.7,
    r: 38.66
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 632.94,
    y1: 264.69,
    x2: 632.94,
    y2: 182.95
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 543.83,
    y1: 180,
    x2: 719.1,
    y2: 180
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtilarIkonu4);
export default __webpack_public_path__ + "static/media/artilarIkonu4.4e29b5c285175dc9b697b33749ff4c89.svg";
export { ForwardRef as ReactComponent };